import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/Rx";

@Injectable()
export class LookupService {
  public lookups = new BehaviorSubject<any[]>([]);
  
  constructor() {
    if (localStorage.getItem("lookups")) {
      this.updateLookups(JSON.parse(localStorage.getItem("lookups")));
    }
    
    this.lookups.subscribe(lookups => {
      if (lookups) {
        localStorage.setItem("lookups", JSON.stringify(lookups));
      }
    });
  }

  updateLookups(newLookups) {
    this.lookups.next(newLookups)
  }

  findLookupByLookupName(name) {
    return this.lookups.getValue().filter(item => item.LookupName === name);
  }

  findLookupByConstnatValue(constant) {
    return this.lookups.getValue().find(item => item.ConstantValue === constant);
  }
}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/webservice/lookup.service.ts